module.exports = __webpack_public_path__ + "assets/profile1.7b64abd4.svg";